module.exports = __webpack_public_path__ + "img/c06_unittechwarchariotchampion_Normal_ua.f3affe60.webp";